import { graphql } from '@/gql';
import type { PaginationInputType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedChatRoomTypeResponse } from '@/models/chatRoom';

export const fetchChatRooms = async (pagination: PaginationInputType): Promise<PaginatedChatRoomTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query ChatRooms($pagination: PaginationInputType) {
        chatRooms(pagination: $pagination) {
          count
          rows {
            id
            phoneNumber1
            phoneNumber2
            callerName
            lastMessage
            lastMessageSentAt
            unreadMessagesCount
            isImportant
            isDone
            createdAt
            updatedAt
          }
        }
      }
    `),
    variables: {
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.chatRooms;
};
